import React, { useEffect, useState } from 'react';
import { AiFillDelete, AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';
import NavBar from '../Navbar';
import { Link } from 'react-router-dom';
import { useAppContext } from '../../Context/AppContext';
import Api from '../../Api/Api'
import Payment from "../Subscription/Payment"
import StripePayment from './Stripe';


function Checkout() {
  const { increaseItemQuantity, decreaseItemQuantity, removeItem } = useAppContext();
  const [first, setFirst] = useState(true)
  const [selectAddress, setSelectAddress] = useState(false)
  const [loading, setLoading] = useState(false)
  const [addresses, setAddresses] = useState([])
  const [cartData, setCartData] = useState(JSON.parse(localStorage.getItem("cart")) || {
    products: [],
    total_price: 0,
    shipping_price: 0,
    total_quantity: 0,
    currency_symbol: "$",
  });

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cartData));
  }, [cartData]);

  const handleIncrease = (id) => {
    increaseItemQuantity(id);
    const updatedCart = { ...cartData };
    updatedCart.products = updatedCart.products.map((item) =>
      item.id === id ? { ...item, quantity: item.quantity + 1 } : item
    );
    updateCartTotals(updatedCart);
  };

  const handleDecrease = (id) => {
    decreaseItemQuantity(id);
    const updatedCart = { ...cartData };
    updatedCart.products = updatedCart.products
      .map((item) =>
        item.id === id ? { ...item, quantity: Math.max(item.quantity - 1, 1) } : item
      )
      .filter((item) => item.quantity > 0);
    updateCartTotals(updatedCart);
  };

  const handleRemove = (id) => {
    removeItem(id);
    const updatedCart = { ...cartData };
    updatedCart.products = updatedCart.products.filter((item) => item.id !== id);
    updateCartTotals(updatedCart);
  };

  const updateCartTotals = (updatedCart) => {
    updatedCart.total_quantity = updatedCart.products.reduce((sum, item) => sum + item.quantity, 0);
    updatedCart.total_price = updatedCart.products.reduce((sum, item) => sum + item.quantity * item.price, 0);
    setCartData(updatedCart);
  };
  const getAddresses = async () => {
    try {
      const { data } = await Api.getAddresses();
      setAddresses(data)
      console.log(data);
    } catch (e) {
      console.log(e);
    }
  }
  useEffect(() => {
    getAddresses()
  }, [])


  const handleSelect = async (id) => {
    setSelectAddress(id)
  }
  return (
    <>
      <NavBar />
      <div className="container mt-5 p-4 rounded shadow bg-light">
        {cartData.total_quantity === 0 ? (
          <div className="text-center py-5">
            <img src="https://cdn-icons-png.flaticon.com/512/2038/2038854.png" alt="Empty Cart" width="150" />
            <h3 className="mt-3"><b>Your Cart is Empty</b></h3>
            <p className="text-muted">Looks like you haven't added anything to your cart yet.</p>
            <Link to="/" className="btn btn-primary mt-2">Continue Shopping</Link>
          </div>
        ) : (
          <div className="row g-4">
            {/* Cart Section */}
            <div className="col-lg-6 col-md-12">
              <h2 className="mb-3 text-center"><b>Cart</b></h2>
              <div className="overflow-auto p-2 border rounded" style={{ maxHeight: "55vh" }}>
                {cartData.products.map((item, index) => (
                  <div key={index} className="d-flex align-items-center justify-content-between border-bottom pb-2 mb-3">
                    <img src={item.image} alt="product" height={80} width={70} className="rounded" />
                    <div className="flex-grow-1 mx-3">
                      <h5 className="fw-bold">{item.title}</h5>
                      <h6 className="text-primary">{cartData.currency_symbol} {item.price}</h6>
                      <div className="d-flex align-items-center gap-2">
                        <button className="btn btn-sm btn-outline-primary px-2" onClick={() => handleDecrease(item.id)}>
                          <AiOutlineMinus size={10} />
                        </button>
                        <span className="fw-bold">{item.quantity}</span>
                        <button className="btn btn-sm btn-outline-primary px-2" onClick={() => handleIncrease(item.id)}>
                          <AiOutlinePlus size={10} />
                        </button>
                      </div>
                    </div>
                    <AiFillDelete type="button" onClick={() => handleRemove(item.id)} className="text-danger fs-4 cursor-pointer" />
                  </div>
                ))}
              </div>

              {/* Cart Summary */}
              <div className="border-top pt-3 mt-3">
                <h5 className="d-flex justify-content-between">
                  <b>Total Items</b>
                  <b>{cartData.total_quantity}</b>
                </h5>
                <h5 className="d-flex justify-content-between">
                  <b>Total Price</b>
                  <b>{cartData.currency_symbol} {cartData.total_price.toFixed(2)}</b>
                </h5>
              </div>
            </div>

            {/* Address Section */}
            <div className="col-lg-6 col-md-12">
              <h2 className="mb-3 text-center"><b>All Addresses</b></h2>

              <div className="overflow-auto p-2 border rounded" style={{ maxHeight: "55vh" }}>
                {addresses?.map((address, index) => (
                  <div key={index} className="p-3 mb-2 border rounded bg-white shadow-sm">
                    <h6 className="fw-bold">{address.Name}</h6>
                    <p className="mb-1">{address.Address_Line_1}, {address.City}, {address.State}, {address.Country} - {address.Pin_Code}</p>
                    <p className="mb-0">Phone: {address.Contact_Number}</p>
                    <button className="btn btn-sm btn-success mt-2 w-100">Select</button>
                  </div>
                ))}
              </div>
              <div className="text-center mb-3 mt-1">
                <Link to="/cartaddress" className="btn btn-primary">Add New Address</Link>
              </div>
            </div>
          </div>
        )}

        {/* Payment Button */}
        {cartData.total_quantity > 0 && (
          <>
            <div className="text-center mt-4">
              <button className="btn btn-dark w-75 py-2 fs-5" onClick={() => alert("Proceeding to Payment")}>
                <b>Proceed to Pay</b>
              </button>
            </div>
            {/* <StripePayment /> */}
            {/* <div><Payment /></div> */}

          </>

        )}
      </div >
    </>

  );
}

export default Checkout;
